import { getStore, setStore, keys } from ".";
import { getUserInfo } from "../api";

/**
 * 
 * @returns {{ 
 *      user_info: {
 *          "name": String,
 *          "email": String,
 *          "mobile": String,
 *          "country_code": String
 *      }
 *      salesperson_info: {
 *          "describe": String,
 *          "name":String,
 *          "email": String,
 *          "mobile": String,
 *          "wechat": String,
 *          "qr_code": String
 *      }
 *  }}
 */
export function getUser() {
    return getStore(keys.user)
}

/**
 * 
 * @returns {{ 
 *      user_info: {
 *          "name": String,
 *          "email": String,
 *          "mobile": String,
 *          "country_code": String
 *      }
 *      salesperson_info: {
 *          "describe": String,
 *          "name":String,
 *          "email": String,
 *          "mobile": String,
 *          "wechat": String,
 *          "qr_code": String
 *      }
 *  }}
 */
export async function setUser() {
    let user = await getUserInfo()
    return setStore(keys.user, user)
}


// WEBPACK FOOTER //
// ./src/store/user.js